import tepService from '@/service/tep-service';
import { ref, reactive } from 'vue';

const saveGridPromise = ref(null);

const state = reactive({
    allRatesList: [],
    radioPribFlag: false,
    isSaveGrid: false,
    statusSaveButton: true,
    isChangeWidget: false,
    selectedItem: null,
});

const loadRatesList = async () => {
    state.allRatesList = await tepService.getAllRatesData();
};

const changeRadioVal = (val) => {
    state.radioPribFlag = val;
};

const changeSavegrid = (val) => {
    state.isSaveGrid = val;
};

const changeStatusSaveButton = (val) => {
    state.statusSaveButton = val
}

const setSaveGridPromise = (promise) => {
    saveGridPromise.value = promise;
}

const waitForGridSave = async () => {
    if(saveGridPromise.value) {
        try {
            await saveGridPromise.value;
        } catch(e) {
            console.error(e);
        } finally {
            saveGridPromise.value = null;
        }
    }
}

const changeWidget = (val) => {
    state.isChangeWidget = val;
}

const getSelectedItem = (item) => {
    state.selectedItem = item;
}

export default {
    state: state,
    loadRatesList: loadRatesList,
    changeRadioVal: changeRadioVal,
    changeSavegrid: changeSavegrid,
    changeStatusSaveButton: changeStatusSaveButton,
    setSaveGridPromise: setSaveGridPromise,
    waitForGridSave: waitForGridSave,
    changeWidget: changeWidget,
    getSelectedItem: getSelectedItem,
}

